import React, { useState } from "react";
import styles from "./GuestRsvpSubmit.module.css";
import { SubmitButton, TextComponent } from "../../../../components";
import placeholderImg from "../../../../assets/dummy.png";
import dots from "../../../../assets/pfdots.png";
import { DotsIcon } from "../../../../components/icons/Icons";
import Modal from "../../../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { GuestMiddleware } from "../../../../Store/Middlewares/GuestMiddleware";
import { useNavigate } from "react-router-dom";
// import { Modal } from "antd";
const RSVPTick = () => {
  return (
    <svg
      viewBox="0 0 276 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svgIcon}
    >
      <path
        d="M258.141 106.657C253.512 101.82 248.724 96.8359 246.92 92.4531C245.25 88.4386 245.152 81.7846 245.054 75.3393C244.869 63.3571 244.673 49.779 235.232 40.3382C225.791 30.8973 212.213 30.7009 200.231 30.5167C193.786 30.4185 187.132 30.3203 183.117 28.6507C178.747 26.846 173.75 22.058 168.913 17.4297C160.442 9.29018 150.817 0.0703125 138 0.0703125C125.183 0.0703125 115.57 9.29018 107.087 17.4297C102.25 22.058 97.2656 26.846 92.8828 28.6507C88.8929 30.3203 82.2143 30.4185 75.769 30.5167C63.7868 30.7009 50.2087 30.8973 40.7679 40.3382C31.327 49.779 31.192 63.3571 30.9464 75.3393C30.8482 81.7846 30.75 88.4386 29.0804 92.4531C27.2757 96.8237 22.4877 101.82 17.8594 106.657C9.71986 115.128 0.5 124.753 0.5 137.57C0.5 150.387 9.71986 160 17.8594 168.483C22.4877 173.32 27.2757 178.305 29.0804 182.688C30.75 186.702 30.8482 193.356 30.9464 199.801C31.1306 211.783 31.327 225.362 40.7679 234.802C50.2087 244.243 63.7868 244.44 75.769 244.624C82.2143 244.722 88.8683 244.82 92.8828 246.49C97.2533 248.295 102.25 253.083 107.087 257.711C115.558 265.85 125.183 275.07 138 275.07C150.817 275.07 160.43 265.85 168.913 257.711C173.75 253.083 178.734 248.295 183.117 246.49C187.132 244.82 193.786 244.722 200.231 244.624C212.213 244.44 225.791 244.243 235.232 234.802C244.673 225.362 244.869 211.783 245.054 199.801C245.152 193.356 245.25 186.702 246.92 182.688C248.724 178.317 253.512 173.32 258.141 168.483C266.28 160.012 275.5 150.387 275.5 137.57C275.5 124.753 266.28 115.141 258.141 106.657ZM194.056 115.055L125.306 183.805C124.394 184.718 123.31 185.442 122.118 185.937C120.926 186.431 119.648 186.685 118.357 186.685C117.066 186.685 115.788 186.431 114.596 185.937C113.404 185.442 112.321 184.718 111.408 183.805L81.9442 154.34C80.1013 152.497 79.066 149.998 79.066 147.392C79.066 144.785 80.1013 142.286 81.9442 140.443C83.7871 138.6 86.2866 137.565 88.8929 137.565C91.4991 137.565 93.9986 138.6 95.8415 140.443L118.357 162.971L180.158 101.157C181.071 100.245 182.154 99.521 183.347 99.0272C184.539 98.5333 185.817 98.2791 187.107 98.2791C188.398 98.2791 189.675 98.5333 190.868 99.0272C192.06 99.521 193.143 100.245 194.056 101.157C194.968 102.07 195.692 103.153 196.186 104.345C196.68 105.538 196.934 106.816 196.934 108.106C196.934 109.397 196.68 110.674 196.186 111.867C195.692 113.059 194.968 114.142 194.056 115.055Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
const GuestRsvpSubmit = () => {
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const EventDetails = useSelector(
    (state) => state?.GuestReducer?.EventDetails
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log("RSVP", RSVP);

  const onSubmitRsvp = () => {
    dispatch(GuestMiddleware.submitRsvp(RSVP, EventDetails)).then((data) => {
      setIsModalOpen(true);
    });
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.dtlusersImg}>
        <div className={styles.dtluserDetail}>
          <div className={styles.images}>
            <img
              src={
                EventDetails?.groom?.image
                  ? EventDetails?.groom?.image
                  : placeholderImg
              }
              className={styles.dtlpfImg}
            />
            <DotsIcon className={styles.dots} />
            {/* <img src={dots} className={styles.dots} /> */}
          </div>
          <TextComponent
            text={EventDetails?.groom?.name}
            textClass={styles.dtlname}
          />
        </div>
        <div className={styles.dtluserDetail}>
          <div className={styles.images}>
            <img
              src={
                EventDetails?.bride?.image
                  ? EventDetails?.bride?.image
                  : placeholderImg
              }
              className={styles.dtlpfImg}
            />
            <DotsIcon className={styles.dots} />
          </div>
          <TextComponent
            text={EventDetails?.bride?.name}
            textClass={styles.dtlname}
          />
          {/* <TextComponent text={"Groom"} textClass={styles.role} /> */}
        </div>
      </div>
      <TextComponent
        text={`Your Wishes for ${EventDetails?.groom?.first_name} and ${EventDetails?.bride?.first_name}`}
        textClass={styles.desc}
      />
      <TextComponent
        text={`${EventDetails?.groom?.first_name} & ${EventDetails?.bride?.first_name}`}
        textClass={styles.BGname}
      />
      <TextComponent text={EventDetails?.name} textClass={styles.category} />
      <TextComponent
        text={
          "Don't forget to leave well wishing note on the couple's wedding wall"
        }
        textClass={styles.noteText}
      />

      {!EventDetails?.is_rsvp_submitted && (
        <div className={styles.btnDiv}>
          <SubmitButton
            title={"Submit RSVP"}
            btnClass={styles.btn}
            onClick={onSubmitRsvp}
            //   onClick={() =>console.log("click")}
          />
        </div>
      )}

      <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        // pinkBg={true}
        onClose={() => {
          navigate(-4);
        }}
        className={styles.modalContent}
      >
        <RSVPTick />
        <TextComponent
          text={"RSVP has been submitted successfully "}
          textClass={styles.modalText}
        />
        <div className={styles.btnDiv}>
          <SubmitButton
            title={"Ok"}
            btnClass={styles.btn}
            onClick={() => {
              navigate(-4);
            }}
            //   onClick={() =>console.log("click")}
          />
        </div>
      </Modal>
    </div>
  );
};

export default GuestRsvpSubmit;
